export default __webpack_public_path__ + "static/media/J_wdt_c_cap_0.d5bb8705.mp3";